var map = {
	"./after_1.jpg": 9516,
	"./after_2.jpg": 5963,
	"./after_3.jpg": 4478,
	"./after_4.jpg": 3125,
	"./after_5.jpg": 5960,
	"./before_1.jpg": 3145,
	"./before_2.jpg": 1646,
	"./before_3.jpg": 1803,
	"./before_4.jpg": 6920,
	"./before_5.jpg": 885
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4676;